<template>
  <div class="row collection">
    <table class="highlight bordered">
      <thead>
        <tr>
          <th @click="sorting('hauler_name')">Hauler
            <i :class="['material-icons', { down: sortDir === 'desc' }]" v-show="sortField === 'hauler_name'">
              arrow_drop_up
            </i>
          </th>
          <th @click="sorting('name')">Region
            <i :class="['material-icons', { down: sortDir === 'desc' }]" v-show="sortField === 'name'">
              arrow_drop_up
            </i>
          </th>
          <th @click="sorting('territory')">Territory
            <i :class="['material-icons', { down: sortDir === 'desc' }]" v-show="sortField === 'territory'">
              arrow_drop_up
            </i>
          </th>
          <th @click="sorting('last_saved_at')">Last Saved
            <i :class="['material-icons', { down: sortDir === 'desc' }]" v-show="sortField === 'last_saved_at'">
              arrow_drop_up
            </i>
          </th>
          <th> Saved By </th>
          <th> &nbsp; </th>
        </tr>
      </thead>
      <tbody v-if="loading" class="stateful centered">
        <span class="stateful__spinner stateful__spinner--huge stateful__spinner--block"></span>
        <span class="stateful__msg">Loading Results...</span>
      </tbody>
      <tbody
        v-else
        v-for="(region, index) in regions"
        :key="region.id">
        <tr @click="toggleVisibility(region)">
          <td>
            <router-link :to="`/haulers/${region.hauler_id}`" target="_blank" class="hauler-link">
              {{region.hauler_name || ''}}
            </router-link>
          </td>
          <td>{{region.name}}</td>
          <td>{{region.territory || 'None'}}</td>
          <td><span v-html="formatUpdatedAt(region.last_saved_at)" /></td>
          <td><user-name :userId="region.last_saved_by || ''" /></td>
          <td class="icons">
            <i v-if="!isActiveFilter('no_service', region)" class="material-icons service">location_on</i>
            <i v-else class="material-icons service-red">location_off</i>
            <i v-if="!isActiveFilter('must_call', region)" class="material-icons service">phone</i>
            <i v-else class="material-icons service-red">phone_disabled</i>
            <i v-if="!isActiveFilter('window_active', region)" class="material-icons service">calendar_today</i>
            <i v-else class="material-icons">event_note</i>
            <i v-if="isActiveFilter('days_out', region)" class="material-icons">filter_3</i>
            <i v-else class="material-icons service">crop_square</i>
          </td>
        </tr>
        <tr v-if="region.isVisible && availabilities.newDeliveries[index]" class="availability-row">
          <td class="table-title"><div>CURRENT<br>AVAILABILITY</div></td>
          <td colspan="5">
            <table class="availability-details">
              <thead>
              <th
                v-for="delivery in availabilities.newDeliveries[index]"
                :key="delivery.id"
                >
                  {{delivery.size.name}}
                </th>
                <th class="divider-header">Empty & Return</th>
                <th>Pickup</th>
              </thead>
              <tbody>
                <tr>
                <td
                  v-for="delivery in availabilities.newDeliveries[index]"
                  :key="delivery.id">
                    <div v-if="region.new_deliveries_no_service" class="bad">No Service</div>
                    <template v-else class="black">
                      <div v-if="delivery.must_call" class="bad">Must Call</div>
                      <div v-if="getBaseAvailability(delivery)">{{ getBaseAvailability(delivery) }}</div>
                      <div v-else-if="!delivery.must_call && !delivery.days_out">{{ determineAvailability(delivery) }}</div>
                      <div v-if="delivery.days_out" >{{ delivery.days_out }} Days Out</div>
                      <div v-if="delivery.window_active">
                        1-{{ delivery.window_days }} Day Window
                      </div>
                    </template>
                  </td>
                  <td :class="['divider-td']">
                    <div v-if="region.availability.emptyReturn.no_service" class="bad">No Service</div>
                    <template v-else class="black">
                      <div v-if="availabilities.returns[index].must_call" class="bad">Must Call</div>
                      <div v-if="getBaseAvailability(availabilities.returns[index])">{{ getBaseAvailability(availabilities.returns[index]) }}</div>
                      <div v-else-if="!availabilities.returns[index].must_call && !availabilities.returns[index].days_out">{{ determineAvailability(availabilities.returns[index]) }}</div>
                      <div v-if="availabilities.returns[index].days_out" >{{ availabilities.returns[index].days_out }} Days Out</div>
                      <div v-if="availabilities.returns[index].window_active" >
                        1-{{ availabilities.returns[index].window_days }} Day Window
                      </div>
                    </template>
                  </td>
                  <td>
                    <div v-if="region.availability.pickUp.no_service" class="bad">No Service</div>
                    <template v-else class="black">
                      <div v-if="availabilities.pickUps[index].must_call" class="bad">Must Call</div>
                      <div v-if="getBaseAvailability(availabilities.pickUps[index])">{{ getBaseAvailability(availabilities.pickUps[index]) }}</div>
                      <div v-else-if="!availabilities.pickUps[index].must_call && !availabilities.pickUps[index].days_out">{{ determineAvailability(availabilities.pickUps[index]) }}</div>
                      <div v-if="availabilities.pickUps[index].days_out" >{{ availabilities.pickUps[index].days_out }} Days Out</div>
                      <div v-if="availabilities.pickUps[index].window_active" >
                        1-{{ availabilities.pickUps[index].window_days }} Day Window
                      </div>
                    </template>
                  </td>
                </tr>
                <tr class="small-table-row" v-if="windows.newDeliveries[index] && windows.newDeliveries[index].window_active">
                  <td :colspan="availabilities.newDeliveries[index].length" class="delivery-window">
                    <strong>Delivery Window </strong> 1-{{ windows.newDeliveries[index].window_days }} Day
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr v-if="region.isVisible && !availabilities.newDeliveries[index]" class="availability-row">
          <td colspan="6" class="center">Loading…</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { format, formatDays } from '../utils/time'
import UserName from '../components/UserName'

export default {
  name: 'AvailabilityCollectionTable',
  components: {
    UserName
  },
  props: {
    regions: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      sortField: 'last_saved_at',
      sortDir: 'desc',
      visibleRegions: {},
      territories: [
        {
          name: 'Midwest',
          value: 'Midwest'
        }, {
          name: 'Southeast',
          value: 'Southeast'
        }, {
          name: 'Northeast',
          value: 'Northeast'
        }, {
          name: 'West',
          value: 'West'
        }
      ]
    }
  },
  computed: {
    availabilities () {
      const availability = {
        pickUps: [],
        returns: [],
        newDeliveries: []
      }

      if (this.regions[0].current_availability) {
        availability.pickUps = this.regions.map(region => {
          const pickUp = region.current_availability.find(i => i.delivery_type === 'pickUp')
          if (pickUp) {
            return pickUp.pickUp || []
          }
          return []
        })
        availability.returns = this.regions.map(region => {
          const emptyReturn = region.current_availability.find(i => i.delivery_type === 'emptyReturn')
          if (emptyReturn) {
            return emptyReturn.emptyReturn || []
          }
          return []
        })
        availability.newDeliveries = this.regions.map((region) => {
          const newDeliveries = region.current_availability.find(i => i.delivery_type === 'newDeliveries')
          const list = newDeliveries ? newDeliveries.newDeliveries : []
          return list
            ? list.sort((a, b) => {
              const aName = Number(a.size.name.split(' ')[0])
              const bName = Number(b.size.name.split(' ')[0])
              return aName - bName
            })
            : []
        })
      }

      return availability
    },
    windows () {
      return {
        newDeliveries: this.regions.map(region => region.current_availability.find(i => i.delivery_type === 'newDeliveries')),
        pickUp: this.regions.map(region => region.current_availability.find(i => i.delivery_type === 'pickUp')),
        emptyReturn: this.regions.map(region => region.current_availability.find(i => i.delivery_type === 'emptyReturn'))
      }
    }
  },
  methods: {
    toggleVisibility (region) {
      this.visibleRegions[region.id] = !this.visibleRegions[region.id]
      this.$set(region, 'isVisible', this.visibleRegions[region.id])
    },
    isVisible (region) {
      return this.visibleRegions[region.id]
    },
    sorting (field) {
      this.sortField = field

      if (!this.sortDir || this.sortDir === 'desc') {
        this.sortDir = 'asc'
      } else {
        this.sortDir = 'desc'
      }

      this.$emit('sorted', { field, sortDir: this.sortDir })
    },
    formatUpdatedAt (date) {
      if (Number.isNaN(Date.parse(date))) {
        return ''
      }

      const updatedDate = new Date(`${date}.400Z`)

      return `<div>${format(updatedDate, 'M/DD/YYYY')}</div> <div>${format(date, 'h:mm a')}</div>`
    },
    checkContractMustCall (record) {
      const fields = [
        'must_call_all',
        'next_day_must_call',
        'same_day_must_call',
        'saturday_must_call',
        'sunday_must_call',
        'two_day_notice_must_call'
      ]
      return fields.some(function (field) {
        return record[field] === true
      })
    },
    isActiveFilter (filter, region) {
      switch (filter) {
        case 'must_call':
          return (
            region.current_service_exceptions.must_call
          )
        case 'no_service':
          return (
            region.current_service_exceptions.no_service ||
            region.new_deliveries_no_service
          )
        case 'window_active':
          return (
            region.current_service_exceptions.window_active
          )
        case 'days_out':
          return region.current_service_exceptions.days_out
      }
    },
    getAvailabilityStatus (avail) {
      const status = []
      if (avail.no_service) return [{ mustCallOrNoService: true, text: 'No Service' }]
      if (avail.must_call_all) return [{ mustCallOrNoService: true, text: 'Must Call' }]
      if (avail.window_active) return [{ mustCallOrNoService: false, text: `${avail.window_days} Day Window`, active: true }]
      const LABELS = {
        same_day: 'Same Day',
        next_day: 'Next Day',
        two_day_notice: 'Two Day Notice',
        saturday: 'Saturday',
        sunday: 'Sunday'
      }
      Object.keys(LABELS).forEach(prefix => {
        const mustCall = avail[`${prefix}_must_call`]
        const active = avail[`${prefix}_active`]
        if (mustCall || active) {
          const label = LABELS[prefix]
          status.push({
            mustCallOrNoService: mustCall,
            text: label,
            active
          })
        }
      })
      return status
    },
    determineAvailability (avail) {
      if (avail.must_call) {
        return 'Must Call'
      }

      if (avail.window_active && avail.days_out) {
        return ` ${avail.window_days} Day Window, \n${formatDays(avail.days_out)} Out`
      }

      if (avail.window_active) {
        return `${avail.window_days} Day Window`
      }

      if (avail.days_out) {
        return `${formatDays(avail.days_out)} Out`
      }

      if (avail.delivery_date.availabilityType !== 'Two Day Notice') {
        return avail.delivery_date.availabilityType
      }

      if (avail.next_available_service) {
        return format(avail.next_available_service, 'M/DD/YYYY')
      }

      if (avail.days_out) {
        return `${avail.days_out} Days Out`
      }

      if (avail.saturday_active) {
        return 'Saturday'
      }

      return ''
    },
    getBaseAvailability (avail) {
      // Get base availability without filter indicators
      if (avail.delivery_date.availabilityType !== 'Two Day Notice') {
        return avail.delivery_date.availabilityType
      }

      if (avail.next_available_service) {
        return format(avail.next_available_service, 'M/DD/YYYY')
      }

      if (avail.saturday_active) {
        return 'Saturday'
      }

      return ''
    }
  },
  watch: {
    regions () {
      this.regions.forEach((region) => {
        if (this.isVisible(region)) {
          this.$set(region, 'isVisible', true)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import 'src/styles/base/_variables.scss';

.bad {
  color: $danger;
}
.black {
  color: #000;
}
.service {
  color: $gray
}
.service-red {
  color: #f34a61;
}
.centered {
  height: 100px;
  display: table-row;
  position: relative;

  span {
    position: absolute;
  }

  .stateful__spinner {
    bottom: 20px;
    left: 45%;
  }

  .stateful__msg {
    bottom: 0px;
    left: 43%;
  }
}

.hauler-link {
  color: #FA8D29;
  cursor: pointer;
}

.availability-row {

  .table-title {
    position: relative;
    color: $dark-gray;
    text-align: left;
    div {
       margin-left: 20px;
    }
  }

  .table-title:after {
    bottom: 10px;
    top: 18px;
    right: 24px;
    max-height: 75%;
  }

  .divider-header, .divider-td  {
    position: relative;
  }

  .table-title:after, .divider-header:before,
  .divider-header:after, .divider-td:after, .divider-td:before {
    content: "";
    position: absolute;
    width: 1px;
    background: $dark-gray;
  }

   .divider-header:after,  .divider-header:before {
     top: 3px;
     height: 120%
   }

  .divider-header:before {
    left: -20px;
  }

  .divider-header:after {
    right: 20px;
  }

  .divider-td:after, .divider-td:before {
    bottom: 6px;
    height: 120%;
  }

  .divider-td:after {
    right: 20px;
  }

  .divider-td:before {
    left: -20px;
  }

  .availability-details {
    thead {
      border-bottom: none;
      th {
        padding-bottom: 0px;
      }
    }
  }
}

tr.small-table-row {
  margin: 0;
  padding: 0;
  td {
    padding:0;
    margin:0;
  }
}

th .material-icons {
  vertical-align: middle;
}

.material-icons.down {
  transform: rotate(180deg);
}

.material-icons {
  transition: transform 0.3s;
  font-size: 24px;
  margin: 0 2px;
}
.delivery-window {
    text-align: center;
}

.filter-info {
  font-size: 0.85em;
  color: $dark-gray;
  margin-top: 4px;
  font-style: italic;
}
</style>
